import Global from '../../store/global-selectors';
import { selectBatchDetailsAppliedFilters, selectBatchDetailsBatch } from '../../store/batches/details/batch.details.selectors';
import { selectOrdersNavSearchData } from '../../store/orders/nav/orders.nav.selectors';
import { mapOrdersFiltersToRequestBody } from '../../services/filtering/api-param-map-service';
import { getOrderStatusFromViewName } from '../../services/api/order-status-from-view-service';
import { getIsBatchDetailsPage } from '../../store/batches/batches.helpers';
import { getSelectedViewFromPathName } from '../../pages/orders-page/orders-left-nav/orders-left-nav-context';

export const buildOrdersGridRequestFilters = ({
  storeGuid,
  orderGridStatus,
  filters,
  fulfillmentPlanIds,
  fulfillmentPlanSetId,
  searchTerm,
}) => {
  return {
    ...filters,
    storeGuid: storeGuid ? [storeGuid] : undefined,
    orderGridStatus: getOrderStatusFromViewName(orderGridStatus),
    fulfillmentPlanIds: fulfillmentPlanIds && fulfillmentPlanIds.length > 0 ? fulfillmentPlanIds : undefined,
    fulfillmentPlanSetId,
    searchTerm,
  };
};

export const buildOrdersGridRequestFiltersFromState = (state, filters, pathname) => {
  const stores = Global.selectSellerActiveStores(state);
  const statusView = getSelectedViewFromPathName(pathname, stores);
  const { storeGuid } = statusView || {};
  const requestStatusViewId = statusView?.parentId || statusView?.id;
  const sellerTimeZone = Global.selectSellerTimeZoneIANA(state);
  const isOnBatchDetailsPage = getIsBatchDetailsPage();
  const activeFilterView = Global.selectOrdersFilteringActiveFilterView(state);
  const appliedFilters = isOnBatchDetailsPage ? selectBatchDetailsAppliedFilters(state) || [] : activeFilterView.appliedFilters || [];
  const filterRequestJson = mapOrdersFiltersToRequestBody(appliedFilters, sellerTimeZone);
  const selectedOrdersIds = Global.selectSelectedOrdersIds(state);
  const { fulfillmentPlanSetId } = selectBatchDetailsBatch(state);
  const { searchTerm } = selectOrdersNavSearchData(state);
  return buildOrdersGridRequestFilters({
    searchTerm,
    storeGuid,
    orderGridStatus: requestStatusViewId,
    filters: filters || filterRequestJson,
    fulfillmentPlanIds: selectedOrdersIds,
    fulfillmentPlanSetId: isOnBatchDetailsPage ? fulfillmentPlanSetId : undefined,
  });
};
